import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-administracion-mensajes',
  templateUrl: './administracion-mensajes.component.html',
  styleUrls: ['./administracion-mensajes.component.css']
})
export class AdministracionMensajesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
